import Page from "webPage/Page";
import Track from "util/Track";

import Gallery, { DIRECTION_FORWARDS } from "webPage/Gallery";
import {handleTestimonials} from "util/handleTestimonials";

Page.register('page-template-homepage', () => {
    let $gallery = $('.js-hero-slider');

    if ($gallery.length > 0) {
        let gallery = new Gallery($gallery, {
            itemClass:          "slider__item",
            pipClass:           "hero__pip",
            navigateClass:      "js-navigate",
            pipsClass:          "js-pips",
            itemsClass:         "js-slider-wrap",
            itemActiveModifier: "active",
            pipActiveModifier:  "active",
            animationDuration:  1200,
            applyMinHeight: false,
        });

        let timeout = galleryTimeout();

        function galleryTimeout() {
            let activeItem = gallery.getActiveElement();
            let timeToRead = ValueHelper.get_time_to_read(activeItem.text().trim(), 2);
            document.documentElement.style.setProperty('--hero-slide-time-to-read', parseInt(timeToRead) + 's');

            return setTimeout(() => {
                gallery.navigate(DIRECTION_FORWARDS);

                setTimeout(() => {
                    timeout = galleryTimeout();
                });
            }, timeToRead * 1000);
        }

        gallery.on('navigate', () => {
            clearTimeout(timeout);
            timeout = galleryTimeout();
        });
    }

    new Track($('.js-track-wrap'), {
        classes: {
            block: "news-cards-wrap",
        },
    });

    handleTestimonials();
});
